<div class="auth-container">
	<div class="auth-wrapper">
		<figure class="auth-logo">
			<img src="./assets/images/logo-ivsw.svg" alt="Logo IVSW" />
		</figure>
		<app-mobile-login-form></app-mobile-login-form>
	</div>
</div>
